import * as z from "zod";
import { SCIM_TOKEN_TTL_MS } from "../scimTokenConfig";
import { mutator } from "./mutator";

export const generateScimTokenSchema = z.object({
  ssoProviderId: z.string(),
  tokenHash: z.string(),
});

export const generateScimToken = mutator({
  redactKeys: ["tokenHash"],
  schema: generateScimTokenSchema,
  resolve: {
    provider: { kind: "ssoProvider", from: "ssoProviderId" },
  },
  permissions: [
    { permission: "tenant:sso_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, args: { provider } }) => {
    await tx.mutate.ssoProvider.update({
      id: provider.id,
      syncMode: "scim",
      jitUserProvisioning: true,
      scimTokenExpiresAt: Date.now() + SCIM_TOKEN_TTL_MS,
      updatedAt: Date.now(),
    });
  },
});
